<template>
  <a-modal
    :title="title"
    :width="900"
    v-model="visible"
    v-if="goodsDataList.formDataMap && goodsDataList.tableDataList"
    :destroyOnClose="true"
    @ok="handleOk"
    :confirmLoading="confirmLoading"
    :bodyStyle="{
      height: '600px',
      'overflow-y': 'auto',
    }"
  >
    <div>
      <!--==============工厂信息==================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Vendor_Information') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Vendor_Name')">
              <span>{{ goodsDataList.formDataMap.orderFactoryname }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Region')">
              <span>{{
                goodsDataList.formDataMap.orderFactoryarea != null
                  ? goodsDataList.formDataMap.orderFactoryarea.join()
                  : ''
              }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Vendor_Address')">
              <span>{{ goodsDataList.formDataMap.orderFactoryaddress }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Contact_Name')">
              <span>{{ goodsDataList.formDataMap.orderFactoryperson }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Telephone')">
              <span>{{ goodsDataList.formDataMap.orderFactoryfixedtel }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Mobile')">
              <span>{{ goodsDataList.formDataMap.orderFactorytel }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.E_mail')">
              <span>{{ goodsDataList.formDataMap.orderFactoryemail }}</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
      <!--==============我的信息==================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Company_Profile') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Company_Name')">
              <span>{{ goodsDataList.formDataMap.orderTrustcompany }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Company_Address')">
              <span>{{ goodsDataList.formDataMap.orderTrustaddress }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Contact_Name')">
              <span>{{ goodsDataList.formDataMap.orderTrustperson }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Telephone')">
              <span>{{ goodsDataList.formDataMap.orderTrustfixedtel }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Mobile')">
              <span>{{ goodsDataList.formDataMap.orderTrusttel }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.E_mail')">
              <span>{{ goodsDataList.formDataMap.orderTrustemail }}</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
      <!--==============产品信息===================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Product_Details') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form
          :form="form"
          @submit="handleSubmit"
          v-for="datasProduct in goodsDataList.tableDataList"
          :key="datasProduct.productName"
        >
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Product_Name')">
              <span>{{ datasProduct.productName }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Item_Number_Style')">
              <span>{{ datasProduct.productModelid }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Quantity')">
              <span>{{ datasProduct.productCount }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Units')">
              <span>{{ datasProduct.productUnit }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Order_Number')">
              <span>{{ datasProduct.orderId }}</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
      <!--===============AQL======================-->
      <div class="page-form-conent">
        <div class="span-tital">AQL&nbsp;&nbsp;&nbsp;</div>
        <a-form v-if="goodsDataList.orderType === '3'">
          <a-form-item :label="$tc('lang.menuGoodsSpace.Inspection_standard')">
            <span>ASTM D5430 Four Point System</span>
            <span>{{ $tc('lang.menuGoodsSpace.point_system') }}</span>
          </a-form-item>
          <a-form-item label="评判标准*" style="text-align: left">
            <a-radio-group
              v-model="goodsDataList.formDataMap.Inspection_Level"
              disabled
            >
              <a-radio :value="1">出货数量开平方根*10</a-radio>
              <a-radio :value="2">
                {{ goodsDataList.formDataMap.orderFabrileveltwo }}&nbsp;
                %出货数量
              </a-radio>
              <a-radio :value="3">
                固定数量&nbsp;{{
                  goodsDataList.formDataMap.orderFabrilevelthree
                }}&nbsp;码
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <div>
            <a-form-item label="可接受质量限制">
              <div>
                <span
                  >{{ $tc('lang.menuGoodsSpace.Max_penalty_points_text') }}:
                </span>
                {{ goodsDataList.formDataMap.productNumber }}
              </div>
              <div>
                <span
                  >{{ $tc('lang.menuGoodsSpace.Max_penalty_points') }}:</span
                >
                {{ goodsDataList.formDataMap.productNumber1 }}
              </div>
              <div style="width: 550px">
                <span style="color: rgb(195, 195, 195)"
                  >{{ $tc('lang.menuGoodsSpace.It_will_be_judged') }}
                </span>
              </div>
            </a-form-item>
          </div>
        </a-form>
        <a-form v-else :form="form" @submit="handleSubmit">
          <!-- <div class="page-from">
            <a-form-item
              :label="$tc('lang.menuGoodsSpace.Inspection_standard')"
            >
              <span>ANSI/ASQ Z1.4 Single Sampling Plan</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Inspection_levels')">
              <span>{{ goodsDataList.formDataMap.aql }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Inspection_Level')">
              <span>{{ goodsDataList.formDataMap.criterion }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Major')">
              <span>{{ goodsDataList.formDataMap.serious }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Minor')">
              <span>{{ goodsDataList.formDataMap.slight }}</span>
            </a-form-item>
          </div> -->
        </a-form>
      </div>
      <!--===============验货时间======================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Inspection_Date') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="page-from">
            <span>{{
              $momentData(goodsDataList.formDataMap.orderServicedate)
            }}</span>
          </div>
        </a-form>
      </div>
      <!--===============检验资料======================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Inspection_data') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form
          :form="form"
          @submit="handleSubmit"
          v-if="goodsDataList.fileList != null"
        >
          <div class="page-from">
            <a-upload
              :fileList="goodsDataList.fileList.fileArray"
              :multiple="true"
            >
            </a-upload>
          </div>
        </a-form>
      </div>
      <!--===============特别注意点======================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Special_Attention') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="page-from">
            <span>{{ goodsDataList.formDataMap.orderRequire }}</span>
          </div>
        </a-form>
      </div>
    </div>
  </a-modal>
</template>
<!--尾期-->
<script>
export default {
  name: 'startFron',
  data() {
    return {
      //列表弹框
      visible: false,
      /*表单数据*/
      formList: {},
      form: this.$form.createForm(this),
      // 防止多次点击
      isClick: true,
      confirmLoading: false,
      title: this.$tc('lang.menuGoodsSpace.Confirm_the_Order'),
    };
  },
  // 数据状态处理全局
  computed: {
    // form表单提交的数据
    goodsDataList: {
      get() {
        return this.$store.state.downOrder.goodsDataList;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          goodsDataList: value,
        });
      },
    },
    // 验货下单返回数据
    dataOrder: {
      get() {
        return this.$store.state.downOrder.dataOrder;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          dataOrder: value,
        });
      },
    },
  },
  watch: {
    goodsDataList: function (val) {
      console.log('===val===', val);
    },
  },
  created() {},
  methods: {
    //数据初始化
    init() {
      this.visible = true;
      this.confirmLoading = false;
      this.goodsDataList.modelType === true
        ? (this.title = this.$tc('lang.menuGoodsSpace.Order_details'))
        : this.title;
    },
    out() {
      this.visible = false;
      this.confirmLoading = false;
    },
    // 确定下单
    handleOk(e) {
      if (this.isClick) {
        this.isClick = false;
        if (this.goodsDataList.modelType === true) {
          this.visible = false;
        } else {
          console.log('e======', e);
          const url = window.location.href;
          const theRequest = new Object();
          // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
          if (url.indexOf('?') !== -1) {
            //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
            const str = url.substr(url.indexOf('?') + 1);
            const strs = str.split('&');
            for (let i = 0; i < strs.length; i++) {
              theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
            }
          }
          if (theRequest.type === '2') {
            this.$store.commit('downOrder/save', { dataOrder: false });
            this.$store.dispatch(
              'downOrder/updateWorkOrder',
              this.goodsDataList,
            );
          } else {
            console.log('=======', theRequest);
            this.$store.commit('downOrder/save', { dataOrder: false });
            this.$store.dispatch(
              'downOrder/startOrderDown',
              this.goodsDataList,
            );
          }
        }
      } else {
        this.$message.error('请勿多次点击!');
        let _this = this;
        setTimeout(function () {
          // 设置延迟事件，1秒后将执行
          _this.isClick = true; // 将isClick设置为true
        }, 1000);
      }
    },
    handleSubmit(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="less">
.page-form-conent {
  .span-tital {
    bottom: 20px;
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .page-from {
    display: flex;
  }
  .ant-form-item-control {
    width: 240px;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
  .ant-row {
    display: flex;
  }
  .ant-form {
    display: inline-block;
    margin-left: 88px;
  }
}
</style>
